export const BOT_TOKEN = process.env.REACT_APP_BOT_TOKEN;
export const GROUP_ID = process.env.REACT_APP_GROUP_ID;